import type { UpdateUserResponse } from '@vy/api-definition';
import type { UseMutationOptions } from 'react-query';
import { useMutation, useQueryClient } from 'react-query';
import { getPrivateApi } from '../../services/api';
import { queryKeys } from '../../services/query-key/query-keys';

type MutationInput = {
  userId: string;
  firstName?: string;
  lastName?: string;
};

export function useUpdateUserName(
  options?: UseMutationOptions<UpdateUserResponse, unknown, MutationInput>,
) {
  const queryClient = useQueryClient();

  const mutationFn = (variables: MutationInput) => {
    const api = getPrivateApi();

    return api.updateUser({
      userId: variables.userId,
      updateUserRequest: {
        firstName: variables.firstName,
        lastName: variables.lastName,
      },
    });
  };

  return useMutation(mutationFn, {
    onSuccess: async () => {
      await queryClient.invalidateQueries(queryKeys.users());
    },
    ...options,
  });
}
